import React, { createContext, useContext, useEffect, useState } from "react";
import {
  getCurrentUser,
  loginUser,
  logoutUser,
  saveUser,
  loadStoredUser,
} from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => loadStoredUser());
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      setUser(null);
      setAuthLoading(false);
      return;
    }

    getCurrentUser()
      .then((res) => {
        setUser(res.user);
        saveUser(res.user);
      })
      .catch((err) => {
        if (err?.status === 401) {
          logoutUser();
          setUser(null);
        }
      })
      .finally(() => setAuthLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await loginUser({ username, password });
    localStorage.setItem("access_token", res.access_token);
    saveUser(res.user);
    setUser(res.user);
    return res;
  };

  const logout = () => {
    logoutUser();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, authLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}